import { render, staticRenderFns } from "./table-loto.vue?vue&type=template&id=7b585360&"
import script from "./table-loto.vue?vue&type=script&lang=js&"
export * from "./table-loto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports